module.exports = __webpack_public_path__ + "img/7.2ea7cb15.jpg";